import { useStore } from "zustand";

import { DEFAULT_LOCALE } from "~/utils/constants";

import type {
  DiningOption,
  KioskSession,
  KioskSessionStore,
  SessionStatus
} from "../types";
import { kioskSessionStore } from "../store";

export function useKioskSession<T>(selector: (state: KioskSessionStore) => T) {
  return useStore(kioskSessionStore, selector);
}

export function useKioskSessionStatus(): Omit<SessionStatus, "idle"> {
  const isActive = useKioskSession(
    (session) =>
      session !== null &&
      typeof session === "object" &&
      Object.keys(session).length > 0
  );

  return isActive ? "active" : "inactive";
}

export function useKioskRedeemingSessionStatus(): SessionStatus {
  return useKioskSession(
    (session) => session?.redeemingSessionStatus ?? "idle"
  );
}

export function useKioskDiningOption(): DiningOption | null {
  return useKioskSession((session) => session?.diningOption ?? null);
}

export function useKioskSessionLocale(): string {
  return useKioskSession((session) => session?.locale ?? DEFAULT_LOCALE);
}

export function useKioskActiveCategoryId(): KioskSession["activeCategoryId"] {
  return useKioskSession((session) => session?.activeCategoryId ?? null);
}
